module.exports = __webpack_public_path__ + "static/media/UniGroteskStdMed.1bb36e22.ttf";